import React from 'react'
import Popup from '../../../components/Popup'

interface LockIntegrationStubPopupProps {
    name: string
    close: () => void
    websiteUrl?: string
    description?: string
    integrationType?: 'lock' | 'roomsharing' // тип интеграции
}

export default function LockIntegrationStubPopup({ name, close, websiteUrl, description, integrationType = 'lock' }: LockIntegrationStubPopupProps) {
    const defaultDescriptions = {
        'Digital Concierge': 'Система управления умными замками для арендного бизнеса. Автоматизация процессов заселения и выезда. Интеграция с различными PMS системами.',
        'RentySoft': 'Платформа для интеграции умных замков с Битрикс, Amo, Yclients, TravelLine, RealtyCalendar и другими системами. Универсальное решение для управления замками различных поставщиков.',
        'RoomSharing': 'Платформа для управления совместной арендой. Система управления доступом к помещениям. Автоматизация процессов аренды.',
        'Bnovo': 'Система управления отелями и гостиницами. Автоматизация рутины и отчетов, усиление revenue, контроль загрузки и управление бронями в одном кабинете.',
        'TravelLine': 'Комплексная система управления отелями и туристическими объектами. Автоматизация бронирования, управления номерами и клиентами.'
    }

    const defaultUrls = {
        'Digital Concierge': 'https://dc.proptech.digital/',
        'RentySoft': 'https://rentysoft.com/',
        'RoomSharing': 'https://rmshare.ru/?utm_source=okidoki&utm_medium=cpc&utm_campaign=okidoki',
        'Bnovo': 'https://bnovo.ru',
        'TravelLine': 'https://www.travelline.ru/'
    }

    const currentDescription = description || defaultDescriptions[name as keyof typeof defaultDescriptions] || 'Интеграция с системой управления умными замками.'
    const currentUrl = websiteUrl || defaultUrls[name as keyof typeof defaultUrls]

    return (
        <Popup maxWidth="500px" onClose={close}>
            <div>
                <div className="commonTitle" style={{marginBottom: 16}}>
                    {name}
                </div>
                <div className="commonSubtitle" style={{marginBottom: 24, lineHeight: '1.5'}}>
                    {currentDescription}
                </div>
                
                {integrationType === 'roomsharing' ? (
                    <div>
                        <div className="commonSubtitle" style={{marginBottom: 16, lineHeight: '1.5'}}>
                            <strong>Как подключить интеграцию:</strong>
                        </div>
                        <ol style={{margin: '0 0 20px 0px', lineHeight: '1.6'}}>
                            <li style={{marginBottom: '8px'}}>
                                Подключитесь {name} к сервису <strong>RoomSharing</strong> (ссылка: {' '}
                                <a 
                                    href="https://rmshare.ru/?utm_source=okidoki&utm_medium=cpc&utm_campaign=okidoki" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ color: '#1FA3EE', textDecoration: 'none' }}
                                >
                                    rmshare.ru
                                </a>
                                )
                            </li>
                            <li style={{marginBottom: '8px'}}>
                                Настройте интеграцию между {name} и RoomSharing согласно инструкциям
                            </li>
                            <li>
                                Подключите RoomSharing к ОкиДоки через нашу интеграцию
                            </li>
                        </ol>
                        
                        <div style={{ 
                            background: '#e3f2fd', 
                            border: '1px solid #bbdefb', 
                            borderRadius: '8px', 
                            padding: '16px',
                            marginBottom: '20px'
                        }}>
                            <p style={{ margin: '0', fontSize: '14px', color: '#1976d2' }}>
                                <strong>Примечание:</strong> Данная интеграция осуществляется через сервис RoomSharing. 
                                Это позволяет подключать различные PMS системы к ОкиДоки через единый интерфейс.
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="commonSubtitle" style={{marginBottom: 24, lineHeight: '1.5'}}>
                        Для подключения интеграции с {name} необходимо оставить заявку на сайте сервиса умного замка. 
                        Наши специалисты свяжутся с вами для настройки интеграции.
                    </div>
                )}

                <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                    {currentUrl && (
                        <button
                            onClick={() => window.open(currentUrl, '_blank')}
                            className="new withTitle secondary _wa"
                        >
                            Перейти на сайт {name}
                        </button>
                    )}
                    
                    {integrationType === 'roomsharing' && (
                        <button
                            onClick={() => window.open('https://rmshare.ru/?utm_source=okidoki&utm_medium=cpc&utm_campaign=okidoki', '_blank')}
                            className="new withTitle secondary _wa"
                        >
                            Перейти в RoomSharing
                        </button>
                    )}

                    <button
                        className="new withTitle _wa"
                        onClick={close}
                    >
                        Закрыть
                    </button>
                </div>
            </div>
        </Popup>
    )
} 